import React, { Component } from "react";
import classNames from "classnames";


export default class NavItem extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if (this.props.onSelect) {
      if (!this.props.disabled) {
        this.props.onSelect(this.props.eventKey, e);
      }
    }
    return true;
  };

  render() {
    let {
      children,
      active,
      className,
      activeKey,
      activeHref,
      onSelect, ...props
    } = this.props;
    className = classNames(className, active ? "active" : "");
    return (
      <li className={className}>
        <a onClick={this.handleClick} {...props}>{children}</a>
      </li>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Link/NavItem.js